import styled from "styled-components";
import palette from "../../lib/styles/palette";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { unloadConveyorList } from "../../modules/conveyor/conveyorsSlice";
import { setOriginalConveyor } from "../../modules/conveyor/conveyorWriteSlice";
import { toFixedSafe } from "../../lib/styles/perttierNumber";


const ComponentList = ({ conveyors, project, ownProject, error, loading }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const onEdit = (conveyor) => {
        dispatch(unloadConveyorList());
        dispatch(setOriginalConveyor(conveyor));
        navigate('/write/conveyor');
    }

    // 에러 발생시
    if (error) {
        return <ComponentListBlock>Unknown Errro!!!</ComponentListBlock>
    }

    // 로딩 중이거나 아직 컨베이어가 없을 때
    if (loading || !conveyors) {
        return null;
    }

    // Weight Summary 계산하기
    const weightSummary = getComponentWeight(conveyors);
    
    return (
        <ComponentListBlock>
            <Content>
                <Caption>
                    <h1>Component List</h1>
                    <span>(Unit: kg, m)</span>
                </Caption>
                <Table>
                    <thead>
                        <tr>
                            <th rowSpan={2} className="title">BC ID.</th>
                            <th colSpan={4}>Belt</th>
                            <th colSpan={6}>Idler</th>
                            <th colSpan={4}>Motor</th>
                            <th colSpan={3}>Brake</th>
                            <th colSpan={2}>Fluid Coup.</th>
                            <th colSpan={3}>Reducers</th>
                            <th colSpan={3}>Gear Coup.</th>
                            <th colSpan={3}>Backstop</th>
                            <th rowSpan={2}>Total<br/>Weight</th>
                            <th rowSpan={2} className="btn-area"></th>
                        </tr>
                        <tr>
                            <th>Width</th>
                            <th>Spec.</th>
                            <th>Length</th>
                            <th>Wt</th>
                            <th>Impact</th>
                            <th>Carry</th>
                            <th>SAC</th>
                            <th>Return</th>
                            <th>SAR</th>
                            <th>Wt</th>
                            <th>kW</th>
                            <th>Hz</th>
                            <th>Poles</th>
                            <th>Wt</th>
                            <th>Model</th>
                            <th>Torque<br/>(Nm)</th>
                            <th>Wt</th>
                            <th>Model</th>
                            <th>Wt</th>
                            <th>Model</th>
                            <th>1/i</th>
                            <th>Wt</th>
                            <th>Model</th>
                            <th>Torque<br/>(Nm)</th>
                            <th>Wt</th>
                            <th>Model</th>
                            <th>Torque<br/>(Nm)</th>
                            <th>Wt</th>
                        </tr>
                    </thead>
                    <tbody>
                        {conveyors && conveyors.map((conveyor, index) => {
                            const { title, body: { input, belt, idlers, drives, brakes, fluidCouplings, reducers, gearCouplings, backstops } } = conveyor;
                            const selectedBelt = belt.selectedBelt;
                            const tapeLength = Number(belt.tapeLength);
                            const beltWeight = belt.weight;

                            return (
                                <tr key={index}>
                                    <td>{title}</td>
                                    {/* 벨트 */}
                                    <td>{input.beltWidth}</td>
                                    <td>{selectedBelt}</td>
                                    <td>{tapeLength}</td>
                                    <td>{beltWeight}</td>
                                    {/* 아이들러 */}
                                    <td>{idlers?.carry?.qty}</td>
                                    <td>{idlers?.impact?.qty}</td>
                                    <td>{idlers?.SAC?.qty}</td>
                                    <td>{idlers?.return?.qty}</td>
                                    <td>{idlers?.SAR?.qty}</td>
                                    <td>{idlers?.weight}</td>
                                    {/* 모터 */}
                                    <td>
                                        {drives && drives.map((drive, index) => (<div key={index}>{drive.selectedMotor}</div>))}
                                    </td>
                                    <td>
                                        {drives && drives.map((drive, index) => (<div key={index}>{drive.frequency}</div>))}
                                    </td>
                                    <td>
                                        {drives && drives.map((drive, index) => (<div key={index}>{drive.poles}</div>))}
                                    </td>
                                    <td>
                                        {drives && drives.map((drive, index) => (<div key={index}>{drive.weight}</div>))}
                                    </td>

                                    {/* 브레이크 */}
                                    <td>
                                        {brakes && brakes.map((brake, index) => (<div key={index}>{brake.model}</div>))}
                                    </td>
                                    <td>
                                        {brakes && brakes.map((brake, index) => (<div key={index}>{brake.torque}</div>))}
                                    </td>
                                    <td>
                                        {brakes && brakes.map((brake, index) => (<div key={index}>{brake.weight}</div>))}
                                    </td>

                                    {/* 유체커플링 */}
                                    <td>
                                        {fluidCouplings && fluidCouplings.map((fluidCoupling, index) => (<div key={index}>{fluidCoupling.selectedFluidCoupling}</div>))}
                                    </td>
                                    <td>
                                        {fluidCouplings && fluidCouplings.map((fluidCoupling, index) => (<div key={index}>{fluidCoupling.weight}</div>))}
                                    </td>

                                    {/* 감속기 */}
                                    <td>
                                        {reducers && reducers.map((reducer, index) => (<div key={index}>{reducer.model}</div>))}
                                    </td>
                                    <td>
                                        {reducers && reducers.map((reducer, index) => (<div key={index}>{reducer.reductionRatioSelected}</div>))}
                                    </td>
                                    <td>
                                        {reducers && reducers.map((reducer, index) => (<div key={index}>{reducer.weight}</div>))}
                                    </td>

                                    {/* 기어커플링 */}
                                    <td>
                                        {gearCouplings && gearCouplings.map((gearCoupling, index) => (<div key={index}>{gearCoupling.model}</div>))}
                                    </td>
                                    <td>
                                        {gearCouplings && gearCouplings.map((gearCoupling, index) => (<div key={index}>{gearCoupling.allowableTorque}</div>))}
                                    </td>
                                    <td>
                                        {gearCouplings && gearCouplings.map((gearCoupling, index) => (<div key={index}>{gearCoupling.weight}</div>))}
                                    </td>
                                    
                                    {/* 백스탑 */}
                                    <td>
                                        {backstops && backstops.map((backstop, index) => (<div key={index}>{backstop.model}</div>))}
                                    </td>
                                    <td>
                                        {backstops && backstops.map((backstop, index) => (<div key={index}>{backstop.torque}</div>))}
                                    </td>
                                    <td>
                                        {backstops && backstops.map((backstop, index) => (<div key={index}>{backstop.weight}</div>))}
                                    </td>
                                    <td>{toFixedSafe(weightSummary.lineTotals[`line${index+1}`], 1)}</td>
                                    <td>
                                        <ActionButton>
                                            {
                                                ownProject && (
                                                    <StyledButton onClick={() => onEdit(conveyor)}>
                                                        Edit
                                                    </StyledButton>
                                                )
                                            }
                                        </ActionButton>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td className="title">Total</td>
                            {/* 벨트 */}
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>{toFixedSafe(weightSummary.itemTotals?.belt, 1)}</td>
                            {/* 아이들러 */}
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>{toFixedSafe(weightSummary.itemTotals?.idlers, 1)}</td>
                            {/* 모터 */}
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>{toFixedSafe(weightSummary.itemTotals?.motors, 1)}</td>
                            {/* 브레이크 */}
                            <td>-</td>
                            <td>-</td>
                            <td>{toFixedSafe(weightSummary.itemTotals?.brakes, 1)}</td>
                            {/* 유체커플링 */}
                            <td>-</td>
                            <td>{toFixedSafe(weightSummary.itemTotals?.fluidCouplings, 1)}</td>
                            {/* 감속기 */}
                            <td>-</td>
                            <td>-</td>
                            <td>{toFixedSafe(weightSummary.itemTotals?.reducers, 1)}</td>
                            {/* 기어커플링 */}
                            <td>-</td>
                            <td>-</td>
                            <td>{toFixedSafe(weightSummary.itemTotals?.gearCouplings, 1)}</td>
                            {/* 백스탑 */}
                            <td>-</td>
                            <td>-</td>
                            <td>{toFixedSafe(weightSummary.itemTotals?.backstops, 1)}</td>
                            {/* Total Weight */}
                            <td>{toFixedSafe(weightSummary.grandTotal, 1)}</td>
                            <td></td>
                        </tr>
                    </tfoot>
                </Table>
            </Content>
        </ComponentListBlock>
    )
}

export default ComponentList;



/* =================   Styles   ================== */
const ComponentListBlock = styled.div`
    // display: flex;
    // img {
    //     width: 100%;
    // }
`;

const Content = styled.div`
    width: 100%;
    overflow-x: auto;
`;

const Caption = styled.div`
    display: flex;
    justify-content: space-between;
    h1 {
        font-size: 1.125rem;
        margin: 0;
        margin-bottom: 1rem;
    }
    span {
        font-size: 0.9rem;
    }
`;

const Table = styled.table`
    //overflow-x: auto;   // 테이블을 감싸는 요소에 적용해야 한다.

    width: 100%;
    border-collapse: separate;
    // border-collapse: collapse;
    font-size: 0.9rem;
    text-align: center;
    thead tr th {
        font-weight: 500;
        padding: 0.5rem;
        background: ${palette.gray[2]};
        border-bottom: 1px solid ${palette.gray[4]};
        // min-width: 120px;
    }
    tbody tr {
        &:nth-child(even) {
            background: ${palette.gray[2]};
        }
    }
    tbody tr td {
        height: 3rem;
        padding: 0.5rem 1rem;
    }
    tfoot {
        height: 3rem;
        background: ${palette.gray[2]};
        // text-align: right;
        font-weight: 500;
        padding: 0.5rem 1rem;
    }
    .title {
        text-align: center;
        min-width: 80px;
    }
    .belt-width {
        min-width: 100px;
    }
    .info-window {
        min-width: 120px;
    }
    .weight {
        min-width: 100px;
    }
    .btn-area {
        min-width: 70px;
    }
    .right-border {
        color: red;
        border-right: 0.5px solid ${palette.gray[4]};
    }
`;

const ActionButton = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    // margin-top: 1rem;
    // margin-bottom: 2rem;
`;

const StyledButton = styled.button`
    padding: 0.125rem 0.25rem;
    border-radius: 4px;
    border: none;
    background-color: ${palette.orange};
    color: white;
    font-size: 0.85rem;
    font-weight: 550;
    text-align: center;
    border: 1px solid transparent;
    &:hover {
        background-color: #fff;
        color: ${palette.orange};
        border: 1px solid ${palette.orange};
        cursor: pointer;
        transition: 0.3s;
    }
`;

/* =================   함 수   ================== */
export const getComponentWeightPerConveyor = (conveyor) => {
    if (!conveyor || !conveyor.body) return;

    const itemArray = ['belt', 'idlers', 'motors', 'reducers', 'fluidCouplings', 'gearCouplings', 'brakes', 'backstops'];

    let lineTotal = 0;

    for (const item in conveyor.body) {
        if (!itemArray.includes(item)) {
            continue;
        }

        if (Array.isArray(conveyor.body[item])) {
            let itemTotal = 0;

            conveyor.body[item].forEach(element => {
                if (element.weight) {
                    // console.log('item weight : ', item, element.weight);
                    itemTotal += Number(element.weight);
                }
            });
            lineTotal += itemTotal
        } else {
            if (conveyor.body[item]?.weight) {
                lineTotal += Number(conveyor.body[item].weight); 
            }
            continue;
        }
    }
    return lineTotal;
}

export const getComponentWeight = (conveyors) => {
    if (!conveyors) return;

    const itemArray = ['belt', 'idlers', 'motors', 'reducers', 'fluidCouplings', 'gearCouplings', 'brakes', 'backstops'];

    const result = {
        lineTotals: {}, // 각 라인별 총 중량을 저장
        itemTotals: {}, // 각 항목별 총 중량을 저장
        grandTotal: 0,  // 전체 중량 합계
    };

    conveyors.forEach((conveyor, index) => {
        let lineTotal = 0;  // 현재 라인의 총중량

        for (const item in conveyor.body) {
            if (!itemArray.includes(item)) {
                //return; // 잘못된 것인가?
                continue;
            }

            if (Array.isArray(conveyor.body[item])) {
                let itemTotal = 0;

                conveyor.body[item].forEach(element => {
                    if (element.weight) {
                        itemTotal += element.weight;    // 개별 항목의 중량을 더함
                    }
                });

                if (!result.itemTotals[item]) {
                    result.itemTotals[item] = 0;
                }

                result.itemTotals[item] += itemTotal;   // 동일 항목들의 중량 합계
                lineTotal += itemTotal;                 // conveyor별 총 중량에 더함
            } else {
                if (!result.itemTotals[item]) {
                    result.itemTotals[item] = 0;
                }
                if (conveyor.body[item]?.weight) {
                    result.itemTotals[item] += Number(conveyor.body[item].weight);
                    lineTotal += conveyor.body[item].weight;
                }
            }
        }

        result.lineTotals[`line${index+1}`] = lineTotal;
        result.grandTotal += lineTotal;                 // 전체 중량 합계에 더함
    });

    return result;
}




